import { useState } from 'react';
import { useSessionStore } from '@stores/sessionStore';
import { useTranslation } from '@stores/translationStore';

interface NamePromptModalProps {
  guestName?: string; // Original guest name from GuestSession
}

export default function NamePromptModal({ guestName }: NamePromptModalProps) {
  const { setPersonalName } = useSessionStore();
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (trimmed) {
      setPersonalName(trimmed);
    }
  };

  const handleUseGuestName = () => {
    if (guestName) {
      setPersonalName(guestName);
    }
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999 }} role="dialog" aria-modal="true" aria-label={t('namePrompt.title') || "What's your name?"}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content" style={{ borderRadius: '16px', overflow: 'hidden' }}>
          <div className="modal-body text-center p-4">
            <div className="mb-3">
              <span style={{ fontSize: '48px' }}>👋</span>
            </div>
            <h4 className="mb-2">{t('namePrompt.title') || "What's your name?"}</h4>
            <p className="text-muted small mb-4">
              {t('namePrompt.description') || 'This will be used to identify your orders and requests'}
            </p>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                className="form-control form-control-lg text-center mb-3"
                placeholder={t('namePrompt.placeholder') || 'Enter your name'}
                value={name}
                onChange={(e) => setName(e.target.value)}
                maxLength={50}
                autoFocus
                aria-label={t('namePrompt.placeholder') || 'Enter your name'}
                style={{ borderRadius: '12px', fontSize: '18px' }}
              />

              <button
                type="submit"
                className="btn btn-primary w-100 py-2 mb-2"
                disabled={!name.trim()}
                style={{ borderRadius: '12px', fontSize: '16px' }}
              >
                {t('namePrompt.continue') || 'Continue'}
              </button>
            </form>

            {guestName && (
              <button
                type="button"
                className="btn btn-link text-muted small"
                onClick={handleUseGuestName}
              >
                {t('namePrompt.useBookingName') || 'Use booking name:'} <strong>{guestName}</strong>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
